import { FormGroup, FormControl, AbstractControl } from '@angular/forms';
import * as _ from 'lodash';
import { startWith, map, debounceTime, take } from 'rxjs/operators';
import * as moment from 'moment'
import { AngularFirestore } from '@angular/fire/firestore';
import { APPS } from '../dummy/app';
import { firestore } from 'firebase';
import { ConvertService } from './convert.service';

export class MappingService {


  public static toNull(value) {
    if (value === "" || value === undefined) {
      return null;
    }
    return value;
  }

  static instituteObj(item: any) {
    const obj = this.toNull(item)
    if (obj) {
      return {
        key: item.key,
        name: this.toNull(item.name),
        instituteType: this.toNull(item.instituteType),
        shortName: this.toNull(item.shortName),
      };
    } else return null;
  }

  static pushToObject(data: firestore.DocumentSnapshot) {
    if (!data.exists) return null;
    return data.data();
  }

  static userObj(item: any) {
    return {
      key: item.key,
      name: this.toNull(item.name),
      displayName: this.toNull(item.displayName),
      email: this.toNull(item.email),
      role: this.toNull(item.role),
      campus: this.campusObj(item.campus),
      uid: this.toNull(item.uid),
    };
  }

  static employeeObj(item: any) {
    return {
      key: item.key,
      name: this.toNull(item.name),
      display_name: this.toNull(item.display_name),
      email: this.toNull(item.email),
      dob: this.toNull(item.dob),
      first_name: this.toNull(item.first_name),
      last_name: this.toNull(item.last_name),
      full_name: this.toNull(item.full_name),
    };
  }

  static yearObj(item: any) {
    return {
      key: item.key,
      name: this.toNull(item.name),
      academic_year: this.toNull(item.academic_year),
    };
  }

  static installmentObj(item: any) {
    return {
      key: item.key,
      name: this.toNull(item.name),
      create_date: this.toNull(item.create_date),
      create_by: this.userObj(item.create_by),
      page_key: this.toNull(item.page_key),
      student: { key: item.student.key },
      last_installment: this.toNull(item.last_installment),
      price: this.toNull(item.price),
      amount: this.toNull(item.amount),
      received_by: this.userObj(item.received_by),
      received_date: this.toNull(item.received_date),
      received_date_key: this.toNull(item.received_date_key),
      term: {
        key: item.term.key,
        code: item.term.code,
        name: item.term.name,
      },
      campus: this.campusObj(item.campus),
      shift: this.toNull(item.shift),
      note: this.toNull(item.note),
    };
  }

  static campusObj(item: any) {
    const obj = this.toNull(item)
    if (obj) {
      return {
        key: item.key,
        name: this.toNull(item.name),
        shortName: this.toNull(item.shortName),
      };
    } else return null;
  }

  static sessionTimeObj(item: any) {
    const obj = this.toNull(item)
    if (obj) {
      return {
        key: item.key,
        name: this.toNull(item.name),
        shortName: this.toNull(item.shortName),
        shift: {
          key: item.shift.key,
          name: item.shift.name,
          id: item.shift.id,
        }
      };
    } else return null;
  }

  static sessionObj(item: any) {
    const obj = this.toNull(item)
    if (obj) {
      return {
        key: this.toNull(item.key),
        days: this.toNull(item.days),
        fromHours: this.toNull(item.fromHours),
        fromHoursNumber: this.toNull(item.fromHoursNumber),
        name: this.toNull(item.name),
        toHours: this.toNull(item.toHours),
        toHoursNumber: this.toNull(item.toHoursNumber),
        shift: this.shiftObj(item.shift)
      }
    } else return null;

  }

  static shiftObj(item: any) {
    const obj = this.toNull(item)
    if (obj) {
      return {
        key: this.toNull(item.key),
        id: this.toNull(item.id),
        duration: this.toNull(item.duration),
        paymentRate: this.toNull(item.paymentRate),
        name: this.toNull(item.name),
        order: this.toNull(item.order),
      }
    } else return null;
  }

  static scholarshipObj(item: any) {
    return {
      key: item.key,
      student: this.toNull(item.student),
      percentage: this.toNull(item.percentage),
      cash: this.toNull(item.cash),
      isScholarship: this.toNull(item.isScholarship),
      isScholarshipLoan: this.toNull(item.isScholarshipLoan),
      isScholarshipSibling: this.toNull(item.isScholarshipSibling),
      approve_by: this.toNull(item.approve_by),
      approve_date: this.toNull(item.approve_date),
      program: this.toNull(item.program),
      sibling: this.toNull(item.sibling),
      scholarshipType: this.toNull(item.scholarshipType),
    };
  }

  static termObj(item: any) {
    const obj = this.toNull(item)
    if (obj) {
      return {
        key: item.key,
        code: item.code,
        name: item.name,
        page_key: this.toNull(item.page_key),
        startterm: this.toNull(item.startterm),
        startDateKey: this.toNull(item.startDateKey),
        endterm: this.toNull(item.endterm),
        endTermKey: this.toNull(item.endTermKey),
        termstatus: this.toNull(item.termstatus),
        note: this.toNull(item.note),
        memo: this.toNull(item.memo),
        maxEnroll: this.toNull(item.maxEnroll),
        status: this.toNull(item.status),
        startEnroll: this.toNull(item.startEnroll),
        startEnrollKey: this.toNull(item.startEnrollKey),
        endEnroll: this.toNull(item.endEnroll),
        endEnrollKey: this.toNull(item.endEnrollKey),
        endPayment: this.toNull(item.endPayment),
        endPaymentKey: this.toNull(item.endPaymentKey),
        dropClass: this.toNull(item.dropClass),
        dropClassKey: this.toNull(item.dropClassKey),
        termType: this.toNull(item.termType),
        term_type: this.toNull(item.term_type),
      };
    } else return null;
  }

  static generationObj(item: any) {
    return {
      key: item.key,
      campus: this.toNull(item.campus),
      generation: this.toNull(item.generation),
      term: {
        key: item.term.key,
        name: item.term.name,
      },
    };
  }

  static abcCourseObj(item: any) {
    return {
      key: item.key,
      campus: this.toNull(item.campus),
      code: this.toNull(item.code),
      endTermKey: this.toNull(item.endTermKey),
      endcourse: this.toNull(item.endcourse),
      generation: {
        key: item.generation.key,
        generation: item.generation.generation,
      },
      name: this.toNull(item.name),
      page_key: this.toNull(item.page_key),
      startDateKey: this.toNull(item.startDateKey),
      startcourse: this.toNull(item.startcourse),
      term: {
        key: item.term.key,
        name: item.term.name,
      },
    };
  }

  static levelObj(item: any) {
    return {
      key: item.key,
      name: this.toNull(item.name),
      objective: this.toNull(item.objective),
      level: this.toNull(item.level),
      nextLevel: this.toNull(item.nextLevel),
      fromScored: this.toNull(item.fromScored),
      toScored: this.toNull(item.toScored),
      passScored: this.toNull(item.passScored),
      failScored: this.toNull(item.failScored),
      success: this.toNull(item.success)
    };
  }
  static studentObj(item: any) {
    const obj = this.toNull(item)
    if (obj) {
      return {
        key: item.key,
        id: this.toNull(item.StudentId),
        puc_id: this.toNull(item.puc_id),
        serial_id: this.toNull(item.serial_id),
        PUCCODE: this.toNull(item.PUCCODE),
        first_name: this.toNull(item.first_name),
        last_name: this.toNull(item.last_name),
        full_name: this.toNull(item.full_name),
        mobile_phone: this.toNull(item.mobile_phone),
        email_address: this.toNull(item.email_address),
        email: this.toNull(item.email),
        gender: this.toNull(item.gender),
        program_academic: this.toNull(item.program_academic),
      };
    } else return null;
  }
  static autoComplete(stateCtrl: AbstractControl, data: any, type) {
    return stateCtrl.valueChanges.pipe(startWith(''),
      map(state => state ? this.filterStates(data, stateCtrl.value, type) : data.slice())
    );
  }


  public static validSelected(control: AbstractControl): { [s: string]: boolean } {
    const value = control.value;
    if (value !== undefined && value !== null && value !== '') {
      if (!value.key && !value.id) {
        return { validKey: true }
      }
    }
  }

  static age18() {
    return moment().add(-18, 'year').toDate();
  }

  static filterStates(data: any, value: any, type: any): any[] {
    if (value.key || value.id || !data) return;
    switch (type) {
      case "code":
        return data.filter(state => state.code.toLowerCase().indexOf(value.toLowerCase()) > -1);
      case "name_en":
        return data.filter(state => state.name_en.toString().toLowerCase().indexOf(value.toLowerCase()) > -1);
      case "name":
        return data.filter(state => state.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
      case "co_number":
        return data.filter(state => state.co_number.toLowerCase().indexOf(value.toLowerCase()) > -1);
      case "description_en":
        return data.filter(state => state.description_en.toLowerCase().indexOf(value.toLowerCase()) > -1);
      case "invoice_number":
        return data.filter(state => state.invoice_number.toLowerCase().indexOf(value.toLowerCase()) > -1);
      case "full_name":
        return data.filter(state => state.full_name.toLowerCase().indexOf(value.toLowerCase()) > -1);
      case "bill_number":
        return data.filter(state => state.bill_number.toLowerCase().indexOf(value.toLowerCase()) > -1);
      case "refNo":
        return data.filter(state => state.refNo.toLowerCase().indexOf(value.toLowerCase()) > -1);
      case "fullname":
        return data.filter(state => state.fullname.toLowerCase().indexOf(value.toLowerCase()) > -1);
      case "name.name":
        return data.filter(state => state.name.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
      default:
        return data.filter(state => state && state[type].toLowerCase().indexOf(value.toLowerCase()) > -1);
    }
  }
  static orderBy(rows: Array<any>, field: string) {
    return _.orderBy(rows, [field])
  }

  static orderByDesc(rows: Array<any>, field: string) {
    return _.orderBy(rows, [field], "desc")
  }

  static groupBy(data: Array<any>, field: string, orderBy: string) {
    const rows = _.uniqBy(data, field)
    return _.orderBy(rows, [orderBy])
  }

  static groupByOrderDesc(data: Array<any>, field: string, orderBy: string) {
    const rows = _.uniqBy(data, field)
    return _.orderBy(rows, [orderBy], ['desc'])
  }
}

export function addMonth(interval: number) {
  return moment().add(interval, 'month').toDate()
}
export function addMonthFromDuration(date: Date, interval: number) {
  return moment(date).add(interval, 'month').toDate()
}

export function yearOfDate(date: Date) {
  return Number(moment(date).format('YYYY'))
}

export function autoComplete(stateCtrl: AbstractControl, data: any, type) {
  return stateCtrl.valueChanges.pipe(startWith(''),
    map(state => state ? filterStates(data, stateCtrl.value, type) : data.slice())
  );
}

export function filterStates(data: any, value: any, type: any): any[] {
  if (value.key || value.id || !data) return;
  return data.filter(state => state && state[type].toLowerCase().indexOf(value.toLowerCase()) > -1);
}

export function validSelected(control: AbstractControl): { [s: string]: boolean } {
  const value = control.value;
  if (value !== undefined && value !== null && value !== '') {
    if (!value.key && !value.id) {
      return { validKey: true }
    }
  }
}

export function toCapitalize(value) {
  let string = null;
  if (value) string = value.toUpperCase().toString().trim();
  return string;
}

export function toDateKey(date: Date) {
  return Number(moment(date).format('YYYYMMDD'))
}


export function orderBy(rows: Array<any>, field: string, ascDesc = "asc") {
  return _.orderBy(rows, [field], ascDesc)
}

export function pageKey() {
  return Number(moment().format('YYYYMMDDHHmmss'))
}

export function pushToArray(snapshot: firestore.QuerySnapshot): Array<any> {
  if (snapshot.empty) return [];
  return snapshot.docs.map(m => ({ ...m.data(), id: m.id }));
}

export function pushToObject(snapshot: firestore.DocumentSnapshot): any {
  if (!snapshot.exists) return null;
  return { ...snapshot.data(), id: snapshot.id }
}

export function getHour(date: Date) {
  return Number(moment(date).format('HH'))
}

export function checkExist(ref: AngularFirestore, collectionName: string, field: string) {
  return (control: AbstractControl) => {
    const value = control.value;
    if (value !== null && value !== '' && value !== undefined) {
      return ref.collection(collectionName, ref => ref.where(field, '==', value.trim()))
        .valueChanges()
        .pipe(
          debounceTime(APPS.DEBOUNCE_TIME),
          take(1),
          map(arr => {
            const val = arr.length > 0 ? { nameAvailable: true } : null;
            return val;
          })
        );
    }
  };
}
export function hourToNumber(time) {
  const { hour, minute } = time;
  return Number(moment(`${hour}:${minute}`, 'hh:mm a').format('HH').toString() + '.' + moment(`${hour}:${minute}`, 'hh:mm a').format('mm').toString());
}

export function getMinute(date: Date) {
  return Number(moment(date).format('MM'))
}


export function toHour(time) {
  const { hour, minute } = time;
  return moment(`${hour}:${minute}`, 'hh:mm a').format('hh:mm a')
}



export function validateAllFormFields(formGroup: FormGroup) {
  Object.keys(formGroup.controls).forEach(field => {
    const control = formGroup.get(field);
    if (control instanceof FormControl) {
      control.markAsTouched({ onlySelf: true });
    } else if (control instanceof FormGroup) {
      this.validateAllFormFields(control);
    }
  });
}

export function toNumber(value) {
  if (value === null || value === "" || value === undefined) {
    return 0;
  }
  if (Number(value) === NaN) return 0;
  return Number(value);
}
export function toNull(value) {
  if (value === null || value === "" || value === undefined) {
    return null;
  }
  return value;
}

export function objectToArray(obj: any) {
  const mapped = Object.keys(obj).map(key => {
    return ({ type: key, value: obj[key] })
  });
  return mapped
}


export function dateRefNo() {
  return moment().format('YYMM')
}


export function groupByArray(data: Array<any>, field: string) {
  const rows = _.uniqBy(data, field)
  return rows
}


export function groupBy(data: Array<any>, field: string, filedOrderBy: string) {
  const rows = _.uniqBy(data, field)
  return _.orderBy(rows, [filedOrderBy])
}


export function getYoutubeId(youtubeUrl: any) {

  if (!youtubeUrl) return null;
  let video_id = `${youtubeUrl}`.split('v=')[1];
  if (!video_id) return
  let ampersandPosition = video_id.indexOf('&');
  if (ampersandPosition != -1) {
    video_id = video_id.substring(0, ampersandPosition);
  }
  return video_id;
}

export const createKeywords = name => {
  const arrName = [];
  let curName = '';
  let nextName = '';
  name.trim().split(/[ .\-_ ]/).forEach(letter => {
    curName += letter;
    arrName.push(ConvertService.toCapitalize(letter));
    arrName.push(ConvertService.toCapitalize(curName));
  });
  name.split('').forEach(letter => {
    nextName += letter;
    arrName.push(ConvertService.toCapitalize(nextName));
  });
  return arrName;
}

export const generateKeywords = names => {
  const [keyword1, keyword2, keyword3, keyword4, keyword5, keyword6, keyword7, keyword8, keyword9, keyword10] = names;
  const suffix1 = keyword1 && keyword1.length > 0 ? `${keyword1}` : '';
  const suffix2 = keyword2 && keyword2.length > 0 ? `${keyword2}` : '';
  const suffix3 = keyword3 && keyword3.length > 0 ? `${keyword3}` : '';
  const suffix4 = keyword4 && keyword4.length > 0 ? `${keyword4}` : '';
  const suffix5 = keyword5 && keyword5.length > 0 ? `${keyword5}` : '';
  const suffix6 = keyword6 && keyword6.length > 0 ? `${keyword6}` : '';
  const suffix7 = keyword7 && keyword7.length > 0 ? `${keyword7}` : '';
  const suffix8 = keyword8 && keyword8.length > 0 ? `${keyword8}` : '';
  const suffix9 = keyword9 && keyword9.length > 0 ? `${keyword9}` : '';
  const suffix10 = keyword10 && keyword10.length > 0 ? `${keyword10}` : '';
  const keywordT1 = createKeywords(`${suffix1}`);
  const keywordT2 = createKeywords(`${suffix2}`);
  const keywordT3 = createKeywords(`${suffix3}`);
  const keywordT4 = createKeywords(`${suffix4}`);
  const keywordT5 = createKeywords(`${suffix5}`);
  const keywordT6 = createKeywords(`${suffix6}`);
  const keywordT7 = createKeywords(`${suffix7}`);
  const keywordT8 = createKeywords(`${suffix8}`);
  const keywordT9 = createKeywords(`${suffix9}`);
  const keywordT10 = createKeywords(`${suffix10}`);
  return [
    ...new Set([
      '~N/A~',
      ...keywordT1,
      ...keywordT2,
      ...keywordT3,
      ...keywordT4,
      ...keywordT5,
      ...keywordT6,
      ...keywordT7,
      ...keywordT8,
      ...keywordT9,
      ...keywordT10,
    ])
  ];
}


export function academicYearObj(item: any) {
  const obj = toNull(item)
  if (obj) {
    return {
      key: item.key,
      name: toNull(item.name),
      code: toNull(item.code),
      dropClass: toNull(item.dropClass),
      dropClassKey: toNull(item.dropClassKey),
      endDate: toNull(item.endDate),
      endDateKey: toNull(item.endDateKey),
      endEnroll: toNull(item.endEnroll),
      endEnrollKey: toNull(item.endEnrollKey),
      endPayment: toNull(item.endPayment),
      endPaymentKey: toNull(item.endPaymentKey),
      startDate: toNull(item.startDate),
      startDateKey: toNull(item.startDateKey),
      startEnroll: toNull(item.startEnroll),
      startEnrollKey: toNull(item.startEnrollKey),
      termType: toNull(item.termType),
      academic_year: toNull(item.academic_year),
      program_term: toNull(item.program_term),
    }
  } else return null;
}
export function campusObj(item: any) {
  const obj = toNull(item)
  if (obj) {
    return {
      key: item.key,
      name: toNull(item.name),
      khName: toNull(item.khName),
      order: toNull(item.order),
      short_name: toNull(item.short_name)
    };
  } else return null;
}
export function schoolObj(item: any) {
  const obj = toNull(item)
  if (obj) {
    return {
      key: item.key,
      name: toNull(item.name),
      khmerName: toNull(item.khmerName),
    };
  } else return null;
}
export function userObj(item: any) {
  const obj = toNull(item)
  if (obj) {
    return {
      key: item.key,
      campus: campusObj(item.campus),
      name: toNull(item.name),
      displayName: toNull(item.displayName),
      email: toNull(item.email),
      role: toNull(item.role),
    };
  } else return null;
}

